import React from "react";
import { useNavigate } from "react-router-dom";

const NAVY = "#1B2951";
const RED = "#E50000";
const MUTED = "#666A7A";

const NotFound: React.FC = () => {
  const navigate = useNavigate();

  return (
    <div className="min-h-screen bg-white flex items-center justify-center px-4 sm:px-6 lg:px-8">
      <div className="max-w-2xl w-full text-center py-20">
        {/* Big 404 + short message */}
        <div>
          <h1
            className="text-[96px] sm:text-[120px] font-extrabold leading-none"
            style={{ color: NAVY }}
            aria-hidden
          >
            404
          </h1>

          <h2
            className="mt-2 text-2xl sm:text-3xl font-semibold"
            style={{ color: NAVY }}
          >
            Page not found
          </h2>

          <p className="mt-4 text-base sm:text-lg" style={{ color: MUTED }}>
            The page you’re looking for either moved or doesn’t exist. Let’s get
            you back on track.
          </p>
        </div>

        {/* Helpful links */}
        <div className="mt-8 flex flex-col sm:flex-row items-center justify-center gap-4">
          <button
            onClick={() => navigate("/")}
            className="inline-flex items-center justify-center px-6 py-3 rounded-lg font-medium shadow-sm focus:outline-none focus:ring-2 focus:ring-offset-2"
            style={{
              background: RED,
              color: "#fff",
              boxShadow: "0 6px 18px rgba(229,0,0,0.12)",
            }}
            aria-label="Go to homepage"
          >
            Go home
          </button>

          <button
            onClick={() => navigate(-1)}
            className="inline-flex items-center justify-center px-6 py-3 rounded-lg font-medium border"
            style={{
              borderColor: NAVY,
              color: NAVY,
              background: "transparent",
            }}
            aria-label="Go back"
          >
            Go back
          </button>
        </div>

        {/* Extra help / contact */}
        <div className="mt-8 text-sm" style={{ color: MUTED }}>
          <p>
            Need help?{" "}
            <a href="/contact" className="underline" style={{ color: NAVY }}>
              Contact support
            </a>
            .
          </p>
        </div>

        {/* Subtle decorative bar to match brand */}
        <div className="mt-12 flex items-center justify-center" aria-hidden>
          <div
            style={{ height: 6, width: 96, background: NAVY, borderRadius: 8 }}
          />
        </div>
      </div>
    </div>
  );
};

export default NotFound;
